import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { PageHero, CTABand } from "../components/ui-kit";
import { Reveal } from "../motion";
import { AREA_GROUPS, AREAS } from "../content";

export default function Atuacao() {
  return (
    <>
      <PageHero
        eyebrow="Atuação"
        titleLines={["Quatro frentes.", "Uma leitura jurídica", "integrada."]}
        lead="O escritório organiza sua atuação em quatro frentes, preservando as conexões entre tributação, atividade empresarial, tecnologia, contratos, disputas e patrimônio. Quando uma questão envolve diferentes competências, o escopo é definido a partir dos fatos e dos objetivos envolvidos."
      />
      <section className="bg-bone py-20 lg:py-28">
        <div className="mx-auto max-w-[1400px] px-6 lg:px-10 space-y-20">
          {AREA_GROUPS.map((g, gi) => (
            <Reveal key={g.group} className="grid lg:grid-cols-[0.5fr_1.5fr] gap-8 lg:gap-16 border-t border-ink/12 pt-10">
              <div>
                <span className="serif text-gold/50 text-5xl">0{gi + 1}</span>
                <h2 className="serif text-2xl lg:text-3xl text-ink mt-4">{g.group}</h2>
              </div>
              <div className="grid sm:grid-cols-2 gap-5">
                {g.items.map((it) => {
                  const a = AREAS[it.slug];
                  return (
                    <Link key={it.slug} to={`/atuacao/${it.slug}`} data-testid={`area-card-${it.slug}`}
                      className="group bg-white border border-ink/10 rounded-xl p-7 hover:border-gold hover:shadow-xl hover:-translate-y-1 transition-all duration-500">
                      <div className="flex items-start justify-between">
                        <h3 className="serif text-xl lg:text-2xl text-ink group-hover:text-gold transition-colors max-w-[85%]">{it.title}</h3>
                        <ArrowUpRight className="text-gold shrink-0" size={20} />
                      </div>
                      <p className="mt-4 text-ink/60 text-sm leading-relaxed line-clamp-3">{a.lead}</p>
                    </Link>
                  );
                })}
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <CTABand
        title={["Questões que atravessam", "mais de uma área."]}
        text="Um contrato pode produzir efeitos tributários. Uma operação digital pode envolver tecnologia, consumo e responsabilidade. Nesses casos, o escritório delimita o escopo e reúne as perspectivas necessárias conforme o contexto."
      />
    </>
  );
}
